/**
 * @generated SignedSource<<a8384d3cfd82c39eadfb6ac5c89c9508>>
 * @relayHash c22bb4a06bd881f1ef1b90298a606f36
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c22bb4a06bd881f1ef1b90298a606f36

import { ConcreteRequest } from 'relay-runtime';
export type useChMedicationDetailByIdQuery$variables = {
  id: string;
  skip: boolean;
};
export type useChMedicationDetailByIdQuery$data = {
  readonly ch_medicationDetailById?: {
    readonly result?: {
      readonly canDelete: boolean | null;
      readonly id: string;
    };
  };
};
export type useChMedicationDetailByIdQuery = {
  response: useChMedicationDetailByIdQuery$data;
  variables: useChMedicationDetailByIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ch_Medication",
      "kind": "LinkedField",
      "name": "result",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canDelete",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ch_SuccessMedicationDetailResult",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useChMedicationDetailByIdQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*:: as any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "ch_medicationDetailById",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useChMedicationDetailByIdQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*:: as any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "ch_medicationDetailById",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "id": "c22bb4a06bd881f1ef1b90298a606f36",
    "metadata": {},
    "name": "useChMedicationDetailByIdQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "650b66c849035cd1ab513f2ebcf40f6d";

export default node;
